import { useEffect } from "react";
import { connect } from "react-redux";
import { setLogin, setUType, setName, setToken, setFacilityId, setFacilityName } from "../action";
import { useNavigate } from "react-router";
const Logout=({commonData, setLogin, setUType, setName, setToken, setFacilityId, setFacilityName})=>
{
    let nav=useNavigate();
    useEffect(()=>{
        setLogin("");
        setUType("");
        setName("");
        setToken("");
        setFacilityId("");
        setFacilityName("");
        localStorage.setItem("token","");
        localStorage.setItem("uname","");
        localStorage.setItem("ulogin","");
        localStorage.setItem("utype","");
        window.utoken="";
        window.ulogin="";
        window.uname="";
        window.utype="";
        nav("/");
    },[]);
    return(
        <>

        </>
    );
}
const connectToStore=(state)=>({commonData:state});
const dispatchToStore=(mydispatch)=>({
    setLogin:(value)=>mydispatch(setLogin(value)),
    setUType:(value)=>mydispatch(setUType(value)),
    setName:(value)=>mydispatch(setName(value)),
    setToken:(value)=>mydispatch(setToken(value)),
    setFacilityId:(value)=>mydispatch(setFacilityId(value)),
    setFacilityName:(value)=>mydispatch(setFacilityName(value))
});
export default connect(connectToStore,dispatchToStore)(Logout);